<template>
  <header>
    <p>JUDITH MILZ</p>

    <div class="buttons">
      <a
        class="download-button"
        download
        href="/JUDITH MILZ_Portfolio_2022-11-14_DE_small.pdf"
      >
        PORTFOLIO (DE)
      </a>
      <a
        class="download-button"
        download
        href="/JUDITH MILZ_Portfolio_2022-11-14_EN_small.pdf"
      >
        PORTFOLIO (EN)
      </a>
    </div>
  </header>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
header {
  box-sizing: border-box;
  position: relative;
  z-index: 10;
  width: 100%;
  padding: 10px;
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: 630px) {
    height: 100%;
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }

  p {
    margin: 0;
  }

  .buttons {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    @media screen and (max-width: 630px) {
      justify-content: center;
      align-items: stretch;
    }

    .download-button {
      margin-bottom: 10px;
      padding: 5px 10px;
      border: 1px solid #000;
      border-radius: 5px;
      background-color: #fff;
      color: #000;
      text-decoration: none;
      font-size: 0.8em;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      transition: all 0.2s ease-in-out;

      @media screen and (max-width: 630px) {
        font-size: 0.7em;
      }

      &:last-child {
        margin-bottom: 0;
      }

      &:hover {
        background-color: #000;
        color: #fff;
      }
    }
  }
}
</style>
